import { render, staticRenderFns } from "./otp2fa.vue?vue&type=template&id=3f26c702&scoped=true&lang=pug&"
import script from "./otp2fa.vue?vue&type=script&lang=js&"
export * from "./otp2fa.vue?vue&type=script&lang=js&"
import style0 from "./otp2fa.vue?vue&type=style&index=0&id=3f26c702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f26c702",
  null
  
)

export default component.exports